import { useTranslation } from 'react-i18next';

import RadixDialog from '../../../../shared/RadixDialog';
import HighlightForm from './HighlightForm.jsx';

export default function CreateHighlightModal({
  isOpen,
  onClose,
  onCreateHighlight,
  campaignName = '',
  campaignUuid = null,
  isNewHire = false,
  isMultiMonth = false,
}) {
  const { t } = useTranslation('campaigns');

  const modalTitle = campaignUuid
    ? t('create.modal.duplicate')
    : t('create.modal.title');

  return (
    <RadixDialog isOpen={isOpen} onClose={onClose} title={modalTitle}>
      <HighlightForm
        onSave={onCreateHighlight}
        onCancel={onClose}
        campaignName={campaignName}
        campaignUuid={campaignUuid}
        isNewHire={isNewHire}
        isMultiMonth={isMultiMonth}
      />
    </RadixDialog>
  );
}
